/**
 * TanStack Query hooks for `publisher-specific-payout-crud-permission-scope`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	publisherSpecificPayoutCrudPermissionScopeQueryKeys,
	type CreatePublisherSpecificPayoutCrudPermissionScopeBody,
	type ListPublisherSpecificPayoutCrudPermissionScopeResponse,
	type PublisherSpecificPayoutCrudPermissionScopeRow,
} from "./api";

export function usePublisherSpecificPayoutCrudPermissionScopeList(): UseQueryResult<ListPublisherSpecificPayoutCrudPermissionScopeResponse, Error> {
	return useQuery({
		queryKey: publisherSpecificPayoutCrudPermissionScopeQueryKeys.list(),
		queryFn: list,
	});
}

export function usePublisherSpecificPayoutCrudPermissionScopeCreate(): UseMutationResult<PublisherSpecificPayoutCrudPermissionScopeRow, Error, CreatePublisherSpecificPayoutCrudPermissionScopeBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: publisherSpecificPayoutCrudPermissionScopeQueryKeys.all });
		},
	});
}

export function usePublisherSpecificPayoutCrudPermissionScopeDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: publisherSpecificPayoutCrudPermissionScopeQueryKeys.all });
		},
	});
}
